<app-dialog [title]="data?.title" [actions]="actions" (action)="action($event)" (close)="action($event)">
    <mat-dialog-content>
        <div class="pt-4">
            <ag-grid-angular
            class="ag-theme-alpine-po-detail"
            [gridOptions]="gridOptions"
            [columnDefs]="columnDefs"
            [modules]="modules"
            (gridReady)="onGridReady($event)"
          >
          </ag-grid-angular>
        </div>
    </mat-dialog-content>
</app-dialog>